var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key-value"},[_c('b-container',_vm._l((_vm.list),function(row){return _c('div',{key:row.key,staticClass:"key-value-row"},[_c('h3',{staticClass:"key-value-row__key"},[_vm._v(" "+_vm._s(row.key)+" ")]),_c('h4',{staticClass:"key-value-row__value"},[_vm._v(" "+_vm._s(row.value)+" ")])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }